import { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import { ModelView } from './ModelViewsSelector.props';
import { StyledViewButton } from './ModelViewsSelector.styles';

interface ViewButtonWithTooltipProps {
  savedView: ModelView;
  currentViewId?: string | null;
  onClick: (event: React.MouseEvent<HTMLButtonElement>, savedView: ModelView) => void;
}

const ViewButtonWithTooltip = ({ savedView, currentViewId, onClick }: ViewButtonWithTooltipProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const checkTruncation = () => {
      if (buttonRef.current) {
        const textElement = buttonRef.current.querySelector('.button-text') as HTMLElement;
        if (textElement) {
          const truncated = textElement.scrollWidth > textElement.clientWidth;
          setIsTruncated(truncated);
        }
      }
    };

    // Use setTimeout to ensure DOM is fully rendered
    const timeoutId = setTimeout(checkTruncation, 0);
    window.addEventListener('resize', checkTruncation);
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkTruncation);
    };
  }, [savedView.name]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick(e, savedView);
  };

  const isActive = savedView.id === currentViewId;

  const button = (
    <StyledViewButton
      ref={buttonRef}
      variant="outlined"
      color="primary"
      onClick={handleClick}
      id={savedView.id}
      isActive={isActive}
    >
      <span className="button-text">{savedView.name}</span>
    </StyledViewButton>
  );

  if (isTruncated) {
    return (
      <Tooltip title={savedView.name} placement="top" arrow disableInteractive>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default ViewButtonWithTooltip;

